import styles from "@/components/switch.module.css";
import clsx from "clsx";
import { ChangeEventHandler, JSX, useId } from "react";

interface SwitchProps {
	isChecked: boolean;
	isDisabled?: boolean;
	onChange?: ChangeEventHandler<HTMLInputElement>;
	title: string;
}

function Switch({
	isChecked,
	isDisabled,
	onChange,
	title,
}: SwitchProps): JSX.Element {
	const inputId = useId();

	return (
		<label
			aria-label={title}
			className={clsx(styles["switch"], isDisabled && styles["disabled"])}
			htmlFor={inputId}
		>
			<input
				checked={isChecked}
				disabled={isDisabled}
				id={inputId}
				onChange={onChange}
				type="checkbox"
			/>
			<span className={styles["slider"]}></span>
		</label>
	);
}

export default Switch;
